import styled from 'styled-components';


function Version({className}) {
    const version = process.env.REACT_APP_VERSION || 'dev';

    return (
        <div className={className}>Version: {version}</div>
    )
}

const StyledVersion = styled(Version)`
    position: fixed;
    bottom: 0;
`;

export default function AppVersion() {
    return <StyledVersion />
}
